import {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { STRINGS } from '../../Constants/ConstantStrings';
import {
  Badge,
  Button,
  CheckBox,
  Icon,
  Input,
  Avatar,
  Switch
} from '../../Universal/NovusDSImports';
import { useReduxDispatch, useReduxSelector } from '../../Store/reduxHooks';
import {
  getMessagesData,
  messagesDataReceived,
  setActiveStatus,
  setNewMessage
} from '../../Store/reducers/Messages';
import { RootState } from '../../store';
// import Card from '../../SharedComponets/Card';
// import ComposeMessage from '../Closures/ComposeMessage';
// import ChatBox from './ChatBox';
import {
  getChatHistory,
  markSelectedMessagesAsRead
} from '../../Store/reducers/RegisteredUsers';
import dayjs from 'dayjs';
import { TabItems, TableWrapper } from '../globalStyles';
import { colorState } from '../../Universal/Foundation';
import TableTitle from '../../SharedComponets/TableTitle';
import {
  btnStyles,
  checkBoxStyles,
  inputStyles,
  avatarStyles,
  switchStyles
} from '../../Universal/NovusDSImports/variants';
import { CountBadge, MessageStyles } from './styles';
import {
  debounceFunction,
  getPermission,
  removeEventManagedByLabel,
  showPopUp
} from '../../CommonUtilities/CommonUtilities';
// import PALoader from '../../SharedComponets/PALoader';
// import NoDataFound from '../../SharedComponets/NoDataFound';
import { NoMessagesData } from '../../Universal/Assets';
import PALoader from '../../SharedComponets/PALoader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MessagesTableRowLimit } from '../../Constants/constants';
import usePrevious from '../../Hooks/UsePrevious';
import SearchPhoneNumber from '../Closures/SearchPhoneNumber';

const Card = lazy(() => import('../../SharedComponets/Card'));
const ComposeMessage = lazy(() => import('../Closures/ComposeMessage'));
const ChatBox = lazy(() => import('./ChatBox'));
const NoDataFound = lazy(() => import('../../SharedComponets/NoDataFound'));

const Messages = () => {
  const messagesData = useReduxSelector(
      (state: RootState) => state.Messages.messagesData
    ),
    selectedClosure = useReduxSelector(
      (state: RootState) => state.Common.selectedClosure
    ),
    isFetchingMessagesData = useReduxSelector(
      (state: RootState) => state.Messages.isFetchingMessagesData
    ),
    newMessage = useReduxSelector(
      (State: RootState) => State.Messages.newMessage
    ),
    currentUser = useReduxSelector(
      (state: RootState) => state.Common.currentUserDetails
    ),
    closuresUnreadMessagesCount = useReduxSelector(
      (state: RootState) => state.Closures.closuresUnreadMessagesCount
    ),
    isActiveStatusChanged = useReduxSelector(
      (state: RootState) => state.Messages.isActiveStatusChanged
    ),
    eventMaintainers = useReduxSelector(
      (state: RootState) => state.Closures.eventMaintainers
    ),
    [selectedUsers, setSelectedUsers] = useState<any>(null),
    [isSelectAll, setIsSelectAll] = useState<boolean>(false),
    [selectedChat, setSelectedChat] = useState<any>(null),
    [selectedUser, setSelectedUser] = useState<number | null>(null),
    [selectedMessages, setSelectedMessages] = useState<any>([]),
    [isComposeMessage, setIsComposeMessage] = useState<boolean>(false),
    [activeTabName, setActiveTabName] = useState<any>('All Messages'),
    [isLoadingInitialData, setIsLoadingInitialData] = useState<boolean>(true),
    [isActiveUsersSwitchSelected, setIsActiveUsersSwitchSelected] =
      useState<boolean>(false),
    previousIsFetchingMessagesData = usePrevious(isFetchingMessagesData),
    dispatch = useReduxDispatch();
  const [searchField, setSearchField] = useState<string>('');
  const timerToSaveDetails = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      dispatch(
        messagesDataReceived({ messagesData: null, shouldAppend: false })
      );
    };
  }, []);

  useEffect(() => {
    if (
      previousIsFetchingMessagesData &&
      !isFetchingMessagesData &&
      isLoadingInitialData
    ) {
      setIsLoadingInitialData(false);
    }
  }, [
    isFetchingMessagesData,
    isLoadingInitialData,
    previousIsFetchingMessagesData
  ]);

  useEffect(() => {
    setSelectedChat(null);
    setSelectedUser(null);
    setActiveTabName('All Messages');
    if (selectedClosure && getPermission(currentUser, 'view_unread_messages')) {
      setSearchField('');
      dispatch(
        getMessagesData({
          closureId: selectedClosure?.id,
          unRead: false,
          limit: MessagesTableRowLimit,
          offset: 0,
          search: searchField
        })
      );
    }
  }, [dispatch, selectedClosure, currentUser]);

  useEffect(() => {
    if (selectedClosure) {
      setIsSelectAll(false);
      setSelectedUsers(null);
    }
  }, [selectedClosure]);

  useEffect(() => {
    if (newMessage) {
      const data: any = JSON.parse(JSON.stringify(messagesData)) || {};
      let isNewUser = true;
      data &&
        Object.keys(data)?.forEach((user: any) => {
          if (
            data[user]?.id === JSON.parse(newMessage.data)?.Meta?.reg_user_id
          ) {
            isNewUser = false;
            data[user].last_message = JSON.parse(
              newMessage.data
            )?.BODY?.message;
            data[user].unread_messages += 1;
            data[user].last_message_time = dayjs();
          }
        });
      if (isNewUser) {
        data[JSON.parse(newMessage.data)?.Meta?.phone_number] = {
          id: JSON.parse(newMessage.data)?.Meta?.reg_user_id,
          last_message: JSON.parse(newMessage.data)?.BODY?.message,
          unread_messages: 1,
          last_message_time: dayjs()
        };
      }
      data.total_unread += 1;
      data.total_users_count += 1;
      dispatch(
        messagesDataReceived({ messagesData: data, shouldAppend: false })
      );
      if (
        selectedChat &&
        selectedChat.id === JSON.parse(newMessage.data)?.Meta?.reg_user_id &&
        getPermission(currentUser, 'view_chatmessage')
      ) {
        dispatch(getChatHistory({ userId: selectedChat.id }));
      }
      dispatch(setNewMessage({ newMessage: null }));
    }
  }, [newMessage]);

  useEffect(() => {
    //Taking everything to default state when any user gets unregistered
    if (isActiveStatusChanged) {
      setActiveTabName('All Messages');
      setIsComposeMessage(false);
      setSelectedChat(null);
      setSelectedUser(null);
      setSelectedUsers(null);
      setIsSelectAll(false);
      setSelectedMessages([]);
    }
  }, [isActiveStatusChanged]);

  useEffect(() => {
    if (selectedChat && !isActiveStatusChanged) {
      messagesData &&
        Object.keys(messagesData)?.map((user: any) => {
          if (
            user !== 'total_unread' &&
            user !== 'total_users_count' &&
            messagesData[user].id === selectedChat.id
          ) {
            setSelectedChat(messagesData[user]);
            setSelectedUser(user);
          }
        });
    } else if (
      messagesData &&
      Object.keys(messagesData)?.length &&
      isActiveStatusChanged &&
      !selectedChat
    ) {
      dispatch(setActiveStatus({ isActiveStatusChanged: false }));
    }
  }, [messagesData, isActiveStatusChanged, selectedChat]);

  useEffect(() => {
    if (selectedUsers === null && isComposeMessage) {
      setIsComposeMessage(false);
    }
  }, [selectedUsers, isComposeMessage]);

  const getMessagesCount = useCallback(() => {
    let count = 0;
    messagesData &&
      Object.keys(messagesData)?.forEach((user: any) => {
        if (messagesData[user].is_active) count += 1;
      });
    return count;
  }, [messagesData]);

  useEffect(() => {
    setSelectedMessages([]);
  }, [selectedChat]);

  useEffect(() => {
    if (isSelectAll) {
      const users: any = {};
      messagesData &&
        Object.keys(messagesData)?.forEach((user: any) => {
          if (
            user !== 'total_unread' &&
            user !== 'total_users_count' &&
            messagesData[user].is_active
          ) {
            // if (!(isUnreadMessages && !messagesData[user].unread_messages))
            users[messagesData[user].id] = true;
          }
        });
      setIsSelectAll(Object.keys(users).length ? true : false);
      setSelectedUsers(users);
    }

    return () => {};
  }, [messagesData]);

  useEffect(() => {
    debounceFunction(timerToSaveDetails, 100, () => {
      dispatch(
        getMessagesData({
          closureId: selectedClosure?.id,
          unRead: activeTabName === 'unread Messages',
          limit: MessagesTableRowLimit,
          offset: 0,
          search: searchField,
          isActiveUsers: isActiveUsersSwitchSelected
        })
      );
    });
  }, [searchField]);

  const handleSelectAllClick = () => {
    setSelectedMessages([]);
    if (isSelectAll) {
      setSelectedUsers(null);
      setIsSelectAll(false);
    } else {
      const users: any = {};
      messagesData &&
        Object.keys(messagesData)?.forEach((user: any) => {
          if (
            user !== 'total_unread' &&
            user !== 'total_users_count' &&
            messagesData[user].is_active
          ) {
            // if (!(isUnreadMessages && !messagesData[user].unread_messages))
            users[messagesData[user].id] = true;
          }
        });
      setIsSelectAll(Object.keys(users).length ? true : false);
      setSelectedUsers(users);
    }
  };

  const handleSelectClick = (user: any) => {
    const users = { ...selectedUsers };
    setSelectedMessages([]);

    if (selectedUsers?.[user.id]) {
      delete users[user.id];
      if (users && Object.keys(users).length !== getMessagesCount())
        setIsSelectAll(false);
    } else {
      users[user.id] = true;
      if (users && Object.keys(users).length === getMessagesCount())
        setIsSelectAll(true);
    }
    setSelectedUsers(users);
  };

  const handleComposeMessageClose = () => {
    setIsComposeMessage(false);
    setSelectedUsers(null);
    setIsSelectAll(false);
  };

  const handleActiveUsersSwitch = () => {
    dispatch(
      getMessagesData({
        closureId: selectedClosure?.id,
        unRead: false,
        limit: MessagesTableRowLimit,
        offset: 0,
        search: searchField,
        isActiveUsers: !isActiveUsersSwitchSelected
      })
    );
    setIsActiveUsersSwitchSelected(!isActiveUsersSwitchSelected);
  };

  const getDateAndTime = (time: any) => {
    if (!dayjs(time).diff(dayjs(), 'd')) {
      return dayjs(time).format('hh:mm A');
    } else if (dayjs(time).diff(dayjs(), 'd') === 1) {
      return 'Yesterday';
    } else {
      return dayjs(time).format('MM/DD/YYYY');
    }
  };

  const getIndeterminateState = () => {
    let isIndeterminate = false;
    //if there are selected users and the selected user count is not equal to total number of users, then the checkbox goes to indeterminate state
    //if UnreadMessages tab is selected, then the selected user count is compared with number of users in that tab (getunreadmessagescount())
    if (
      selectedUsers &&
      Object.keys(selectedUsers)?.length &&
      Object.keys(selectedUsers).length !== getMessagesCount()
    )
      isIndeterminate = true;
    return isIndeterminate;
  };

  const getNextSetOfData = () => {
    dispatch(
      getMessagesData({
        closureId: selectedClosure?.id,
        unRead: activeTabName === 'unread Messages',
        limit: MessagesTableRowLimit,
        offset: messagesData && Object.keys(messagesData)?.length - 2,
        shouldAppend: true,
        search: searchField,
        isActiveUsers: isActiveUsersSwitchSelected
      })
    );
  };
  const doubleTickIcon = (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9425 1.20312L4.34761 8.79806L1.49951 5.94996M16.4995 1.20312L8.90458 8.79806L7.95521 7.84869"
        stroke="#687080"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
  const renderSectionBody = () => {
    return (
      <div className="h-100 w-100 d-flex flex-column">
        {!isLoadingInitialData &&
        ((messagesData && Object.keys(messagesData)?.length > 2) ||
          searchField?.length) ? (
          <div className="select-all-wrapper d-flex justify-content-between align-items-center">
            <Button
              role="button"
              id={`select-all-button`}
              tabIndex={0}
              aria-label="select-all-button"
              onClick={handleSelectAllClick}
              onKeyDown={(event: any) => {
                if (event.key === 'Enter') {
                  handleSelectAllClick();
                }
              }}
              disabled={!getMessagesCount()}
              aria-disabled={!getMessagesCount()}
              {...btnStyles.tertiary}
            >
              <CheckBox
                selected={isSelectAll}
                data-testid="select-all-checkbox"
                onClick={handleSelectAllClick}
                onKeyDown={(e: any) => {
                  if (e.key === ' ') {
                    handleSelectAllClick();
                  }
                }}
                indeterminate={getIndeterminateState()}
                {...checkBoxStyles}
                className="me-2"
              />
              {isSelectAll ? STRINGS.CLEAR_ALL : STRINGS.SELECT_ALL}
            </Button>
          </div>
        ) : null}
        {messagesData && Object.keys(messagesData)?.length > 2 ? (
          <div
            className="table-messages"
            id="table-messages-scroll"
            data-testid="table-messages-scroll"
          >
            <InfiniteScroll
              dataLength={Object.keys(messagesData).length - 2}
              style={{ overflow: 'unset' }}
              next={getNextSetOfData}
              hasMore={
                Object.keys(messagesData).length - 2 <
                messagesData.total_users_count
              }
              loader={
                <div className="p-4">
                  <PALoader />
                </div>
              }
              scrollableTarget="table-messages-scroll"
            >
              {messagesData &&
                Object.keys(messagesData)?.map((user: any) => {
                  if (user === 'total_unread' || user === 'total_users_count')
                    return <></>;
                  return (
                    <div
                      data-testid={'message-item'}
                      aria-label={`Click here to see messages from user : ${user}`}
                      tabIndex={0}
                      role="button"
                      className={`${
                        selectedChat?.id === messagesData[user]?.id &&
                        'selected-message'
                      } ${
                        !messagesData[user].is_active && 'disabled'
                      } messages-wrapper`}
                      onClick={() => {
                        if (messagesData[user].is_active) {
                          setSelectedUser(user);
                          setSelectedChat(messagesData[user]);
                        }
                      }}
                      onKeyDown={(event: any) => {
                        if (
                          event.key === 'Enter' &&
                          messagesData[user].is_active
                        ) {
                          setSelectedChat(messagesData[user]);
                          setSelectedUser(user);
                        }
                      }}
                    >
                      <div className="left-wrapper">
                        <CheckBox
                          tabIndex={0}
                          id={`checkbox-${user}`}
                          data-testid={`checkbox-${user}`}
                          onKeyDown={(event: any) => {
                            if (event.key === ' ') {
                              handleSelectClick(messagesData[user]);
                            }
                          }}
                          selected={selectedUsers?.[messagesData[user]?.id]}
                          onClick={(e) => {
                            e?.stopPropagation();
                            handleSelectClick(messagesData[user]);
                          }}
                          disabled={!messagesData[user]?.is_active}
                          aria-disabled={!messagesData[user]?.is_active}
                          {...checkBoxStyles}
                        />
                        <div>
                          <Avatar size="s" {...avatarStyles} />
                        </div>
                        <div
                          aria-label="chat-history"
                          className="align-items-center"
                        >
                          <div className="d-flex">
                            <h1
                              className={
                                messagesData[user].unread_messages
                                  ? 'unread-msg'
                                  : 'read-msg'
                              }
                            >
                              <div
                                className={`d-flex align-items-center gap-2 ${
                                  messagesData[user].unread_messages === 0
                                    ? 'messages-read'
                                    : 'messages-unread'
                                }`}
                              >
                                {user}
                                {messagesData[user].last_message &&
                                  messagesData[user]?.is_active &&
                                  doubleTickIcon}
                              </div>
                            </h1>
                            {!messagesData[user]?.is_active && (
                              <p
                                title="View History"
                                className="disabled-msg"
                                onClick={() => {
                                  setSelectedChat(messagesData[user]);
                                  setSelectedUser(user);
                                }}
                              >
                                View History
                              </p>
                            )}
                          </div>
                          {messagesData[user].last_message && (
                            <p title={messagesData[user].last_message}>
                              {messagesData[user].last_message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="right-wrapper">
                        {messagesData[user].last_message_time && (
                          <p className="date-time-wrapper">
                            {getDateAndTime(
                              messagesData[user].last_message_time
                            )}
                          </p>
                        )}
                        {messagesData[user].unread_messages ? (
                          <Badge variant="info">
                            {messagesData[user].unread_messages}
                          </Badge>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
            </InfiniteScroll>
          </div>
        ) : (
          <>
            <NoDataFound
              src={NoMessagesData}
              description={STRINGS.NO_MESSAGES}
              alt={'no-messages-data'}
              isAbsolute
              subMsgDescription={
                STRINGS.YOUR_MESSAGE_LIST_IS_EMPTY_BECAUSE_YOU_HAVE_NO_USERS
              }
            />
          </>
        )}
      </div>
    );
  };

  const handleMarkAsRead = () => {
    if (!selectedMessages?.length) {
      showPopUp(
        STRINGS.PLEASE_SELECT_ATLEAST_ONE_MESSAGE_TO_MARK_AS_READ,
        'error'
      );
      return;
    }
    dispatch(
      markSelectedMessagesAsRead({
        messageIds: selectedMessages,
        userId: selectedChat.id,
        fetchMessages: true,
        closureId: selectedClosure?.id,
        closureUnreadMessagesCount: closuresUnreadMessagesCount,
        isUnreadMessages: activeTabName === 'unread Messages',
        searchField: searchField,
        isActiveUsers: isActiveUsersSwitchSelected
      })
    );
    setSelectedMessages([]);
  };

  const handleClear = () => {
    setSelectedUsers(null);
    setSelectedMessages([]);
    setIsSelectAll(false);
  };

  const handleTabChange = (tab: string) => {
    setSelectedUsers(null);
    setIsSelectAll(false);
    setActiveTabName(tab);
    //clearing the isactiveusers filter when switching tabs
    if (isActiveUsersSwitchSelected) {
      setIsActiveUsersSwitchSelected(false);
    }
    dispatch(
      getMessagesData({
        closureId: selectedClosure?.id,
        unRead: tab === 'unread Messages',
        limit: MessagesTableRowLimit,
        offset: 0,
        search: searchField
      })
    );
  };

  return (
    <Card className="w-100">
      <TableWrapper
        id="table-group"
        isActiveUsersSwitchSelected={isActiveUsersSwitchSelected}
      >
        <TableTitle
          title={STRINGS.MESSAGES}
          message={removeEventManagedByLabel(
            selectedClosure?.wea_short_msg_english,
            eventMaintainers
          )}
        >
          {getPermission(currentUser, 'outbound_message_frontend') &&
          messagesData &&
          Object.keys(messagesData)?.length > 2 ? (
            <Button
              role="button"
              tabIndex={0}
              data-testid="compose-message-button"
              onClick={() => {
                if (selectedUsers && Object.keys(selectedUsers)?.length)
                  setIsComposeMessage(true);
                else
                  showPopUp(
                    STRINGS.PLEASE_SELECT_ATLEAST_ONE_USER_TO_SEND_MESSAGE,
                    'error'
                  );
              }}
              onKeyDown={(event: any) => {
                if (event.key === 'Enter') {
                  if (selectedUsers && Object.keys(selectedUsers)?.length)
                    setIsComposeMessage(true);
                  else
                    showPopUp(
                      STRINGS.PLEASE_SELECT_ATLEAST_ONE_USER_TO_SEND_MESSAGE,
                      'error'
                    );
                }
              }}
              {...btnStyles.primary}
            >
              <Icon
                icon={'message'}
                stroke={colorState.icon.default['primary-inverse']}
                width={'16px'}
                height={'16px'}
              />
              {STRINGS.COMPOSE_MESSAGE}
            </Button>
          ) : null}
        </TableTitle>
        <div id="table-tabs">
          <div
            className="d-flex left-wrapper gap-2 flex-wrap"
            onClick={() => {
              setSelectedChat(null);
              setSelectedUser(null);
            }}
          >
            <TabItems
              role="button"
              id={`all-messages-tab`}
              data-testid="all-messages-tab"
              tabIndex={0}
              aria-label="all-messages-tab"
              aria-pressed={activeTabName === 'All Messages'}
              onClick={() => {
                handleTabChange('All Messages');
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleTabChange('All Messages');
                }
              }}
              selectedtab={activeTabName === 'All Messages'}
            >
              {STRINGS.ALL_MESSAGES}
            </TabItems>
            <TabItems
              role="button"
              id={`unread-messages-tab`}
              data-testid="unread-messages-tab"
              tabIndex={0}
              aria-label="unread-messages-tab"
              aria-pressed={activeTabName === 'unread Messages'}
              onClick={() => {
                handleTabChange('unread Messages');
              }}
              onKeyDown={(event: any) => {
                if (event.key === 'Enter') {
                  handleTabChange('unread Messages');
                }
              }}
              selectedtab={activeTabName === 'unread Messages'}
            >
              <CountBadge activeTabName={activeTabName}>
                {isFetchingMessagesData ? '' : messagesData?.total_unread}
              </CountBadge>
              {STRINGS.UNREAD_MESSAGES}
            </TabItems>
          </div>
          <div className="right-wrapper" role="tablist">
            <div className="d-flex gap-2 align-items-center ">
              {activeTabName !== 'unread Messages' &&
                messagesData &&
                Object.keys(messagesData)?.length > 2 && (
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="active-users  d-flex flex-nowrap text-nowrap"
                      data-testid="active-users-switch"
                    >
                      Active Conversations
                    </div>
                    <Switch
                      data-testid="active-users-switch"
                      className="active-users-switch"
                      selected={isActiveUsersSwitchSelected}
                      onClick={handleActiveUsersSwitch}
                      onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                          handleActiveUsersSwitch();
                        }
                      }}
                      accessibleText={true}
                      accessibleTextColor="black"
                      {...switchStyles}
                    />
                  </div>
                )}
              {(selectedUsers && Object.keys(selectedUsers)?.length) ||
              selectedMessages?.length ? (
                <TabItems
                  role="tab"
                  id={`clear-tab`}
                  tabIndex={
                    (!selectedUsers || !Object.keys(selectedUsers)?.length) &&
                    !selectedMessages?.length
                      ? -1
                      : 0
                  }
                  aria-label="clear-tab"
                  className="table-clear-tab"
                  aria-disabled={
                    (!selectedUsers || !Object.keys(selectedUsers)?.length) &&
                    !selectedMessages?.length
                  }
                  onClick={handleClear}
                >
                  <Icon
                    icon={'eraser'}
                    className="eraser-icon"
                    stroke={colorState.icon.default.secondary}
                    width={16}
                    height={16}
                    alt="eraser-icon"
                  />
                  {STRINGS.CLEAR}
                </TabItems>
              ) : null}
              <SearchPhoneNumber
                searchField={searchField}
                setSearchField={setSearchField}
              />
            </div>
          </div>
        </div>

        {isLoadingInitialData ? (
          <PALoader />
        ) : (
          <MessageStyles className="d-flex overflow-auto flex-grow-1 flex-column">
            {selectedChat || isComposeMessage ? (
              <div className="messages-grid">
                <section
                  className={
                    selectedChat &&
                    (activeTabName !== 'unread Messages' ||
                      selectedChat?.unread_messages)
                      ? 'left'
                      : 'middle'
                  }
                >
                  {renderSectionBody()}
                </section>
                {selectedChat &&
                (activeTabName !== 'unread Messages' ||
                  selectedChat?.unread_messages) ? (
                  <Suspense fallback={<PALoader />}>
                    <section className="middle">
                      <ChatBox
                        selectedChat={selectedChat}
                        selectedMessages={selectedMessages}
                        setSelectedMessages={setSelectedMessages}
                        setSelectedUsers={setSelectedUsers}
                        setIsSelectAll={setIsSelectAll}
                        isSelectAll={isSelectAll}
                        selectedUsers={selectedUsers}
                        activeTabName={activeTabName}
                        selectedUser={selectedUser}
                        handleMarkAsRead={handleMarkAsRead}
                      />
                    </section>
                  </Suspense>
                ) : null}
                {isComposeMessage && (
                  <Suspense fallback={<PALoader />}>
                    <section
                      className="right"
                      tabIndex={0}
                      aria-label="right-section"
                      data-testid="compose-message-section"
                    >
                      <ComposeMessage
                        onClose={() => {
                          setIsComposeMessage(false);
                        }}
                        selectedUsers={
                          selectedUsers && Object.keys(selectedUsers)
                        }
                        handleClose={handleComposeMessageClose}
                        fetchMessages={true}
                        closureId={selectedClosure?.id}
                        activeTabName={activeTabName}
                        isSelectAll={isSelectAll}
                        isActiveUsersSwitchSelected={
                          isActiveUsersSwitchSelected
                        }
                      />
                    </section>
                  </Suspense>
                )}
              </div>
            ) : (
              renderSectionBody()
            )}
          </MessageStyles>
        )}
      </TableWrapper>
    </Card>
  );
};

export default Messages;
